<template>
  <div class="c-grade-selector">
    <el-popover
      placement="bottom"
      trigger="click"
      width="228"
      popper-class="c-course-selector"
      v-model="visiblePopover"
    >
      <div>
        <el-input v-model="filteredCourse" prefix-icon="el-icon-search"/>
        <div style="height: 260px;overflow:auto;" ref="ulContainer">
          <ul>
            <li
              v-for="(item, index) in visibleCourseList"
              :key="item.course_id+index"
              class="c-select-item"
              :class="item.course_id === value?'is-active':''"
              @click="onItemClick(item)">{{item.course_name}}</li>
              <li style="height: 20px;" class="c-select-item" ref="lastItem"></li>
          </ul>
        </div>
      </div>
      <el-input
        class="c-select-input"
        readonly
        v-model="selectedCourseName"
        suffix-icon="el-icon-arrow-down"
        slot="reference"></el-input>
    </el-popover>
  </div>
</template>

<script>
import { getCourseList } from '@/api/pt';
import { getSign } from '@/utils';

export default {
  name: 'CrouseSelector',
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    value: {
      type: String,
      default: '',
    },
    total: {
      type: Number,
      default: 0,
    },
    defaultName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      filteredCourse: '',
      visibleCourseList: this.data,
      visiblePopover: false,
      startPage: 2,
      currentTotal: this.total,
    };
  },
  computed: {
    selectedCourseName() {
      const course = this.data.find((item) => item.course_id === this.value);
      return (course && course.course_name) || this.defaultName;
    },
    isAll() {
      return this.currentTotal <= this.visibleCourseList.length;
    },
  },
  watch: {
    filteredCourse(v) {
      this.startPage = 1;
      this.loadChapterList(v, this.startPage);
    },
  },
  mounted() {
    this.initObserver();
  },
  methods: {
    onItemClick(item) {
      this.visiblePopover = false;
      this.$emit('input', item.course_id);
      this.$emit('change', item);
    },
    initObserver() {
      const observer = new IntersectionObserver((entries) => {
        const [lastItem] = entries;
        if (lastItem.isVisible && !this.isAll) {
          this.loadChapterList(this.filteredCourse, this.startPage);
          this.startPage += 1;
        }
      }, {
        root: this.$refs.ulContainer,
        threshold: 0.2,
        trackVisibility: true,
        delay: 100,
      });
      observer.observe(this.$refs.lastItem);
    },
    loadChapterList(courseName, page = 2, limit = 10) {
      const isProd = !window.location.host.includes('test') && !window.location.port.includes('8080');
      const campusId = isProd ? '20011' : '88902';
      const param = {
        page,
        course_name: courseName,
        page_size: limit || 10,
        campus_id: JSON.parse(localStorage.getItem('CRM_USER_INFO') || '{}').campusId || campusId,
      };
      param.sign = getSign(param);
      return getCourseList(param).then((res) => {
        if (res.code === 200) {
          if (page === 1) {
            this.visibleCourseList = res.data.course_list;
          } else {
            this.visibleCourseList = this.visibleCourseList.concat(res.data.course_list);
            // this.$emit('list-change', this.visibleCourseList);
          }
          this.$nextTick(() => {
            this.$emit('list-change', this.visibleCourseList);
            this.currentTotal = res.data.total_count;
          });
        }
      });
    },
  },
};
</script>
<style lang="scss">
.c-course-selector {
  height: 300px;
  overflow: auto;
  .c-select-item {
    font-size: 14px;
    margin: 10px 0;
    color: rgba(102, 102, 102, 1);
    &:hover {
      color: rgba(25, 137, 250, 1);
    }
    &.is-active {
      color: rgba(25, 137, 250, 1);
    }
  }
}
</style>
<style lang="scss" scoped>
.c-grade-selector {
  .c-name {
    color: #000;
    font-size: 17px;
    margin-bottom: 30px;
  }
  .c-select-input {
    width: 2.28rem;
    height: 38px;
    border-radius: 4px;
    margin-bottom: 8px;
    /deep/ .el-input__inner {
      color: rgba(0, 0, 0, 1);
      font-size: 16px;
      font-weight: bold;
      font-family: PingFangSC-Medium, PingFang SC;
      border-color: rgba(196, 200, 210, 1);
    }
  }
}
</style>
